import type { DirectiveType } from '@/types'
import Icon from '@/assets/images/icon-loading.png'

const maskClass = 'loading-mask'
function appendMask(el: HTMLElement) {
  let mask = el.querySelector('.' + maskClass)
  if (!mask) {
    mask = document.createElement('div')
    mask.innerHTML = `<img src='${Icon}'/>`
    mask.classList.add(maskClass, 'abs-full')
    el.appendChild(mask)
  }
}

function removeMask(el: HTMLElement) {
  const mask = el.querySelector('.' + maskClass)
  if (mask) {
    el.removeChild(mask)
  }
}

const Loading: DirectiveType = {
  name: 'loading',
  updated(el, binding, vnode, prevVnode) {
    if (binding.value) {
      appendMask(el)
    } else {
      removeMask(el)
    }
  },
}

export default Loading
